import { RefObject, useEffect, useState } from 'react'

import { useAppSelector } from '~/redux/hooks'
import { selectMenuIsExpanded } from '~/redux/slices/menu'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function useProgressBarScrolling<T extends HTMLElement>(ref: RefObject<T>): void {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const [prevScrollpos, setPrevScrollpos] = useState<number | undefined>(undefined)
  const isMenuOpen = useAppSelector(selectMenuIsExpanded)
  useEffect(() => {
    if (typeof window === 'undefined') return
    const handleScroll = () => {
      const currentScrollPos = window.scrollY
      const isScrollingUp = prevScrollpos && prevScrollpos > currentScrollPos

      if (isScrollingUp && ref.current && !isMenuOpen && !isMobile) {
        ref.current.style.top = '64px'
      } else if (ref.current) {
        ref.current.style.top = '0'
      }
      setPrevScrollpos(currentScrollPos)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [prevScrollpos, ref, isMobile, isMenuOpen])
}
